/**
 * Styles pour la zone d'input
 * Design moderne inspiré de la landing page avec des bordures moins arrondies
 */
export const INPUT_AREA_STYLES = `
  /* Input area */
  .ringado-input-area {
    padding: 16px 20px;
    border-top: 1px solid #e5e7eb;
    background: white;
    border-radius: 0 0 12px 12px; /* Moins arrondi */
    position: relative;
    flex-shrink: 0;
    /* Ombre subtile pour définir la séparation */
    box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.05);
  }

  .ringado-input-container {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px; /* Moins arrondi */
    padding: 3px;
    transition: all 0.2s ease;
  }

  .ringado-input-container:focus-within {
    border-color: #6b7280;
    box-shadow: 0 0 0 1px rgba(107, 114, 128, 0.1);
    background: white;
  }

  .ringado-input {
    flex: 1;
    padding: 10px 14px;
    border: none;
    border-radius: 6px; /* Moins arrondi */
    outline: none;
    font-size: 14px;
    background: transparent;
    transition: all 0.2s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: #374151;
    min-height: 22px;
  }

  .ringado-input::placeholder {
    color: #9ca3af;
  }

  .ringado-input:focus {
    background: white;
  }

  .ringado-send-button {
    width: 36px;
    height: 36px;
    background: #111827;
    color: white;
    border: none;
    border-radius: 6px; /* Moins arrondi */
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    flex-shrink: 0;
    position: relative;
    overflow: hidden;
    color: white;
    fill: white;
    padding: 0;
  }

  .ringado-send-button:hover {
    background: #374151;
    transform: scale(1.02);
  }

  .ringado-send-button:active {
    transform: scale(0.98);
  }

  .ringado-send-button:disabled {
    background: #d1d5db;
    color: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }

  .ringado-send-button svg {
    width: 16px;
    height: 16px;
    fill: white !important;
    display: block;
    margin: 0 auto;
  }

  /* Decline email button - Modern minimalist design */
  .ringado-decline-email {
    margin-top: 12px;
    text-align: center;
  }

  .ringado-decline-email button {
    background: none;
    border: none;
    color: #9ca3af;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 6px;
    transition: all 0.15s ease;
    position: relative;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .ringado-decline-email button:hover {
    color: #6b7280;
    background: rgba(107, 114, 128, 0.05);
  }

  .ringado-decline-email button:active {
    transform: scale(0.98);
  }

  /* Responsive adjustments */
  @media (max-width: 480px) {
    .ringado-input-area {
      padding: 10px 12px;
    }

    .ringado-input {
      font-size: 13px;
      padding: 7px 10px;
    }

    .ringado-send-button {
      width: 32px;
      height: 32px;
    }

    .ringado-send-button svg {
      width: 14px;
      height: 14px;
    }
  }

  @media (max-width: 350px) {
    .ringado-input-container {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
      padding: 8px;
    }

    .ringado-send-button {
      width: 100%;
      height: 36px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
    }
    
    .ringado-send-button svg {
      display: none;
    }
    
    .ringado-send-button::after {
      content: 'Send';
    }
  }
`;
